import type { CandidatePhoto } from '../types';
import { mockCandidateFileType } from './mockCandidateFileType';

export function mockCandidatePhoto(
  overrides: Partial<CandidatePhoto> = {}
): CandidatePhoto {
  return {
    id: 1,
    name: 'candidate-photo',
    extension: 'jpg',
    size: 204800,
    absolutePath: 'https://example.com/uploads/photo.jpg',
    type: mockCandidateFileType(),
    scope: 'candidate',
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-07-15T12:30:00.000Z',
    ...overrides,
  };
}
